import { render, staticRenderFns } from "./FilesAppSettingsAppearance.vue?vue&type=template&id=1d0fcc36"
import script from "./FilesAppSettingsAppearance.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesAppSettingsAppearance.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports